module.exports = "<div class=\"lds-ring\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>\n"